import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function emailFundacaoService() {
	const api = useApi()

	async function getTemplatesEmail(query = '?=') {
		return api.query(`${window.origin}${URLS.email_templates}${query}`)
	}

	async function getFundacoesContatos(query = '?=') {
		return api.query(`${window.origin}${URLS.fundacao_contatos}${query}`)
	}

	async function sendEmail(data, query = '?=') {
		return api.mutation(
			`${window.origin}${URLS.send_email}${query}`,
			'post',
			data
		)
	}

	async function getEmailEnvinhado(id, query = '') {
		return api.query(`${window.origin}${URLS.email_enviados}${id}/${query}`)
	}

	async function getFiltrosFundacaoEmail(query = '?=') {}

	return {
		getTemplatesEmail,
		getFundacoesContatos,
		sendEmail,
		getEmailEnvinhado,
		...api,
	}
}
